export default "__VITE_ASSET__BhhM49VJ__"